var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.l_visible
        ? _c("v-checkbox", {
            ref: "control",
            staticClass: "dynamic_check_box",
            class: {
              large: _vm.large
            },
            attrs: {
              value: _vm.currentValue,
              label: _vm.l_label,
              loading: _vm.loading,
              disabled: _vm.jeDisabled,
              "hide-details": _vm.hideDetails
            },
            on: {
              change: function(val) {
                _vm.setDirty(true)
                _vm.update(val)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }